import React from 'react';

interface Props {
    className?: string;
}

export const MarkAsReadIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M20,5.6l-10-5l-10,5l0,11.3c0,1.4,1.1,2.5,2.5,2.5h15c1.4,0,2.5-1.1,2.5-2.5L20,5.6z M16.2,16.9H3.8c-0.7,0-1.2-0.6-1.2-1.2
                V9.4l7.5,3.8l7.5-3.8v6.2C17.5,16.3,16.9,16.9,16.2,16.9z M10,10.6L2.5,6.9L10,3.1l7.5,3.8L10,10.6z"
            />
        </svg>
    );
};
